//main import
import React, { useState, useEffect, useRef, Fragment } from 'react';
import { Modal, Container } from 'react-bootstrap';
import { Map, TileLayer, WMSTileLayer, Marker, Popup, LayersControl, ScaleControl } from "react-leaflet";
import { FaMapMarkedAlt, FaBookOpen, FaDoorOpen } from "react-icons/fa";
import axios from "axios";

//leaflet import
import MarkerClusterGroup from "react-leaflet-markercluster";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "react-leaflet-markercluster/dist/styles.css";
import './css/customleafletstyle.css';

//custom import
import { DarkModal, TableBlock } from "./styled/mapstyled";
import { ActiveButton } from "./styled/buttonlinkstyled";
import SideMenu from './sidemenu';
import EntranceLink from './entrancelink';
import InfoLink from './infolink';
import LegendLink from './legendlink';
import ShareLink from './sharelink';
import LoadingModal from './loadingmodal'
import LocateControl from './locationfly';

//picture import
import usermarker from './img/mark.png';
import mask_aa from './img/mask_v2_aa.png';
import mask_ab from './img/mask_v2_ab.png';
import mask_ac from './img/mask_v2_ac.png';
import mask_ba from './img/mask_v2_ba.png';
import mask_bb from './img/mask_v2_bb.png';
import mask_bc from './img/mask_v2_bc.png';
import mask_ca from './img/mask_v2_ca.png';
import mask_cb from './img/mask_v2_cb.png';
import mask_cc from './img/mask_v2_cc.png';

//custom css import
import './css/sidestyle.css'
import './css/contentstyle.css'
import './css/tablestyle.css'
import './css/modalloader.css'

/*設定MapDiv於瀏覽器視窗大小設定調整*/
let mapStyle;
//判斷手機視窗調整高度
function mapboxsetup() {
    //alert(navigator.userAgent) device information
    //判斷是否為 FireFox_mobile
    if (navigator.userAgent.match("FxiOS")) {
        mapStyle = {
            width: `100vw`,
            height: `100vh`
        }
    }
    //判斷是否為 Edge_mobile
    if (navigator.userAgent.match("EdgiOS")) {
        mapStyle = {
            width: `100vw`,
            height: `100vh`
        }
    }
    //判斷是否為Google Chrome_mobile
    if (navigator.userAgent.match("CriOS")) {
        mapStyle = {
            width: `100vw`,
            height: `88.5vh`
        }
    }
    //判斷是否為 Edge_mobile
    if (navigator.userAgent.match("Version/13.0.5")) {
        mapStyle = {
            width: `100vw`,
            height: `88.5vh`
        }
    }

};
//呼叫function => mapboxsetup()
mapboxsetup();

//口罩marker setup
const addUserMarker = new L.Icon({
    iconUrl: usermarker,
    iconSize: [40, 40],
});

//地圖框架建立
const MapDiv = () => {
    //build layers control group
    const { BaseLayer } = LayersControl;

    // LocateControl setup
    // https://stackoverflow.com/questions/54099898/react-locate-on-map
    // https://www.npmjs.com/package/leaflet.locatecontrol
    const locateOptions = {
        position: 'topleft',
        drawCircle: false,
        onActivate: () => { } // callback before engine starts retrieving locations
    }

    // build map with hook state
    // const { MapCenter, MapZoom, usePosition } = useAction();
    const [MapCenter, setMapCenter] = useState([23.738116, 120.738455]);
    const [markerPosition, setMarkerPosition] = useState([23.738116, 120.738455]);
    const [MapZoom, setMapZoom] = useState(8);
    const [MapData, setMapData] = useState([]);
    const [Loading, setLoading] = useState(true);
    const [userMarker, setUserMarker] = useState(false);

    // build useRef
    const refEntrance = useRef(null);

    // URL JSON
    const URL = 'https://raw.githubusercontent.com/kiang/pharmacies/master/json/points.json'

    useEffect(() => {
        const fetchMapData = async () => {
            await axios
                .get(URL)
                .then(d => {
                    setMapData(d.data.features);
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(
                            success => {
                                const deviceLat = success.coords.latitude;
                                const deviceLong = success.coords.longitude;
                                // console.log(deviceLat.toFixed(6) + ", " + deviceLong.toFixed(6));
                                // alert(success);
                                setMapCenter([deviceLat.toFixed(6), deviceLong.toFixed(6)]);
                                setMapZoom(18);
                                setUserMarker(true);
                                setMarkerPosition([deviceLat.toFixed(6), deviceLong.toFixed(6)]);
                                setLoading(false);
                            },
                            error => {
                                // alert(error.message);
                                console.log(error.message);
                                setLoading(false);
                            },
                            {
                                enableHighAccuracy: true,
                                timeout: 1000,
                                maximumAge: 1000
                            }
                        );
                    }
                })
                .catch(error => {
                    alert(error.message);
                    console.log(error.message);
                    setLoading(false);
                });
            setTimeout(() => {
                refEntrance.current.startOpen();
            }, 1000);
        };
        fetchMapData();
    }, [URL]);

    //getUserPosition
    function locatePosition() {
        //UserMarker setup
        setUserMarker(false);
        setLoading(true);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(success => {
                const deviceLat = success.coords.latitude;
                const deviceLong = success.coords.longitude;
                console.log(deviceLat.toFixed(6) + ", " + deviceLong.toFixed(6));
                setMapCenter([deviceLat.toFixed(6), deviceLong.toFixed(6)]);
                setMapZoom(18);
                setMarkerPosition([deviceLat.toFixed(6), deviceLong.toFixed(6)]);
                setUserMarker(true);
                setLoading(false);
            }, error => {
                alert(error);
                console.log(error);
                setLoading(false);
            }, {
                enableHighAccuracy: true,
                timeout: 1000,
                maximumAge: 1000
            });
        } else {
            alert('Please check your geolocation!!');
            setLoading(false);
        }
    }

    //get closest medstation
    function getClosestLocation(e) {
        e.preventDefault();
        let maskType = e.target.value;
        // console.log(maskType);
        //UserMarker setup
        setUserMarker(false);
        setLoading(true);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(UserLocation);
        } else {
            alert('Please check your geolocation!!');
            setLoading(false);
        }
        // Callback function for asynchronous call to HTML5 geolocation
        function UserLocation(position) {
            ClosestLocation(position.coords.latitude, position.coords.longitude);
        }

        // https://www.geodatasource.com/developers/javascript
        function distanceCalculator(useLat1, useLon1, useLat2, useLon2) {
            let lat1 = useLat1;
            let lon1 = useLon1;
            let lat2 = useLat2;
            let lon2 = useLon2;
            let unit = "K";
            // console.log(lat1 + ',' + lon1 + ',' + lat2 + ',' + lon2 + ',' + unit)
            // https://www.geodatasource.com/developers/javascript
            let radlat1 = (Math.PI * lat1) / 180;
            let radlat2 = (Math.PI * lat2) / 180;
            let theta = lon1 - lon2;
            let radtheta = (Math.PI * theta) / 180;
            let dist =
                Math.sin(radlat1) * Math.sin(radlat2) +
                Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = (dist * 180) / Math.PI;
            dist = dist * 60 * 1.1515;
            if (unit === "K") {
                dist = dist * 1.609344;
            }
            if (unit === "N") {
                dist = dist * 0.8684;
            }
            return dist;
        }

        function ClosestLocation(latitude, longitude) {
            let minDif = 99999;
            let closest = null;
            if (maskType === 'adult') {
                const getMaskTypeData = MapData.filter(d => d.properties.mask_adult > 0)
                // console.log(getAdultData)
                for (let i = 0; i < getMaskTypeData.length; ++i) {
                    let dif = distanceCalculator(
                        latitude,
                        longitude,
                        getMaskTypeData[i].geometry.coordinates[1],
                        getMaskTypeData[i].geometry.coordinates[0],
                    );
                    if (dif < minDif) {
                        closest = i;
                        minDif = dif;
                        // console.log("minDif:" + minDif);
                    }
                }
                setMarkerPosition([latitude.toFixed(6), longitude.toFixed(6)]);
                setMapZoom(18);
                setUserMarker(true);
                setLoading(false);
                // alert(getMaskTypeData[closest].properties.name);
                setMapCenter([getMaskTypeData[closest].geometry.coordinates[1], getMaskTypeData[closest].geometry.coordinates[0]])
            }
            if (maskType === 'child') {
                const getMaskTypeData = MapData.filter(d => d.properties.mask_child > 0)
                // console.log(getAdultData)
                for (let i = 0; i < getMaskTypeData.length; ++i) {
                    let dif = distanceCalculator(
                        latitude,
                        longitude,
                        getMaskTypeData[i].geometry.coordinates[1],
                        getMaskTypeData[i].geometry.coordinates[0],
                    );
                    if (dif < minDif) {
                        closest = i;
                        minDif = dif;
                        // console.log("minDif:" + minDif);
                    }
                }
                setMarkerPosition([latitude.toFixed(6), longitude.toFixed(6)]);
                setMapZoom(18);
                setUserMarker(true);
                setLoading(false);
                // alert(getMaskTypeData[closest].properties.name);
                setMapCenter([getMaskTypeData[closest].geometry.coordinates[1], getMaskTypeData[closest].geometry.coordinates[0]])
            }

        }
    }

    // addMarkers
    const addMarkers = MapData.map((d, i) => {
        if (isNaN(d.geometry.coordinates[1]) || isNaN(d.geometry.coordinates[0])) {
            return console.log('data problem!!');
        }
        // const markerLink = ["https://www.google.com/maps?q=" + d.geometry.coordinates[1] + "," + d.geometry.coordinates[0]];
        const markerLink = ["https://www.google.com/maps?q=" + d.properties.name + "-" + d.properties.address];

        // mask number color control
        let adultFontStyle, childFontStyle;
        // adult
        if (d.properties.mask_adult === 0) { adultFontStyle = { color: `red`, fontWeight: 900 } }
        if (0 < d.properties.mask_adult && d.properties.mask_adult <= 100) { adultFontStyle = { color: `brown`, fontWeight: 900 } }
        if (100 < d.properties.mask_adult && d.properties.mask_adult <= 1000) { adultFontStyle = { color: `orange`, fontWeight: 900 } }
        if (1000 < d.properties.mask_adult) { adultFontStyle = { color: `green`, fontWeight: 900 } }
        // child
        if (d.properties.mask_child === 0) { childFontStyle = { color: `red`, fontWeight: 900 } }
        if (0 < d.properties.mask_child && d.properties.mask_child <= 100) { childFontStyle = { color: `brown`, fontWeight: 900 } }
        if (100 < d.properties.mask_child && d.properties.mask_child <= 1000) { childFontStyle = { color: `orange`, fontWeight: 900 } }
        if (1000 < d.properties.mask_child) { childFontStyle = { color: `green`, fontWeight: 900 } }

        // Mask style control
        let useMask;

        if (d.properties.mask_adult > 100 && d.properties.mask_child > 100) { useMask = mask_aa; }
        if (d.properties.mask_adult > 100 && d.properties.mask_child > 0 && d.properties.mask_child <= 100) { useMask = mask_ab; }
        if (d.properties.mask_adult > 100 && d.properties.mask_child === 0) { useMask = mask_ac; }

        if (d.properties.mask_adult > 0 && d.properties.mask_adult <= 100 && d.properties.mask_child > 100) { useMask = mask_ba; }
        if (d.properties.mask_adult > 0 && d.properties.mask_adult <= 100 && d.properties.mask_child > 0 && d.properties.mask_child > 0 && d.properties.mask_child <= 100) { useMask = mask_bb; }
        if (d.properties.mask_adult > 0 && d.properties.mask_adult <= 100 && d.properties.mask_child === 0) { useMask = mask_bc; }

        if (d.properties.mask_adult === 0 && d.properties.mask_child > 100) { useMask = mask_ca; }
        if (d.properties.mask_adult === 0 && d.properties.mask_child > 0 && d.properties.mask_child <= 100) { useMask = mask_cb; }
        if (d.properties.mask_adult === 0 && d.properties.mask_child === 0) { useMask = mask_cc; }

        // marker setup
        const StationMarker = new L.Icon({
            iconUrl: useMask,
            iconSize: [80, 70],
        });

        // Set Table Control
        function buildTable(d) {
            const table_row = [
                "<tr><th>　</th><th>一</th><th>二</th><th>三</th><th>四</th><th>五</th><th>六</th><th>日</th></tr>"
            ];
            const table_column = ["上午", "下午", "晚上"];
            for (let i = 0; i < table_column.length; i++) {
                const column_temp = [`<th>${table_column[i]}</th>`];
                for (let j = 0; j < 7; j++) {
                    if (d[i * 7 + j] === "N") {
                        column_temp.push("<td>O</td>");
                    } else {
                        column_temp.push("<td>X</td>");
                    }
                }
                table_row.push("<tr>" + column_temp.join("") + "</tr>");
            }
            // console.log(table_row.join(""));
            const HTML = table_row.join("");

            return HTML;
        }

        // Content Modal Insert
        function ModalInsert() {
            // ModalInsert開關設計
            const [show, setShow] = useState(false);

            // ModalInsert開關function
            function modalClick() {
                setShow(!show)
            }

            return (
                <Fragment>
                    <ActiveButton variant="primary" onClick={modalClick}>
                        <FaBookOpen />內容開啟
                    </ActiveButton>
                    <Modal
                        show={show}
                        onHide={modalClick}
                        size="lg"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title className='useTitle'>{d.properties.name}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Container className='textJhengHei'>
                                <ul className='useList '>
                                    <li>縣市：{d.properties.county}</li>
                                    <li>鄉鎮：{d.properties.town + d.properties.cunli}</li>
                                    <li>門市地址：{d.properties.address}</li>
                                    <li>營業時間：<br />
                                        <TableBlock>
                                            <tbody
                                                id="settable"
                                                dangerouslySetInnerHTML={{
                                                    __html: buildTable(d.properties.service_periods)
                                                }}
                                            />
                                        </TableBlock>

                                    </li>
                                    <li><font style={adultFontStyle}>成人口罩：{d.properties.mask_adult}</font></li>
                                    <li><font style={childFontStyle}>幼兒口罩：{d.properties.mask_child}</font></li>
                                    <li>聯絡資訊：{d.properties.phone}</li>
                                    <li>更新時間：{d.properties.updated}</li>
                                </ul>
                            </Container>
                        </Modal.Body>
                        <Modal.Footer>
                            <ActiveButton
                                onClick={modalClick}
                            ><FaDoorOpen />離開
                            </ActiveButton>
                        </Modal.Footer>
                    </Modal>
                </Fragment>
            );
        }

        return (
            <Marker
                key={i}
                position={[d.geometry.coordinates[1], d.geometry.coordinates[0]]}
                icon={StationMarker}
            // onTouchStart={e => { e.preventDefault() }}
            >
                <Popup>
                    {"店名：" + d.properties.name}
                    <br />
                    {"縣市：" + d.properties.county}
                    <br />
                    {"地址：" + d.properties.address}
                    <br />
                    <font style={adultFontStyle}>{"成人口罩庫存：" + d.properties.mask_adult}</font>
                    <br />
                    <font style={childFontStyle}>{"幼兒口罩庫存：" + d.properties.mask_child}</font>
                    <br />
                    <div style={{ textAlign: 'center' }}>
                        <a href={markerLink} target='_blank' without="true" rel="noopener noreferrer">
                            <ActiveButton><FaMapMarkedAlt />點我進入</ActiveButton>
                        </a>
                        <br />
                        <ModalInsert />
                    </div>
                    <br />
                    {"更新時間：" + d.properties.updated}
                </Popup>
            </Marker >
        )
    });

    return (
        <Map
            style={mapStyle}
            preferCanvas={true}
            center={MapCenter}
            zoom={MapZoom}
            viewport={{}}
            useFlyTo={false}
            maxZoom={19}//OSM maxZoom limit =>19
            doubleClickZoom={false}
            onTouchStart={{ passive: true }}
        >
            {/*LayersControl*/}
            <LayersControl position="topleft">
                {/*https://wiki.openstreetmap.org/wiki/Tile_servers*/}
                <BaseLayer name="臺灣通用電子地圖">
                    {/* https://ithelp.ithome.com.tw/articles/10194831 */}
                    <WMSTileLayer
                        attribution='&amp;copy <a href="https://maps.nlsc.gov.tw/S09SOA/">國土測繪圖資服務雲</a> contributors'
                        url="https://wmts.nlsc.gov.tw/wmts/EMAP/default/GoogleMapsCompatible/{z}/{y}/{x}.jpg"
                    />
                </BaseLayer>
                <BaseLayer name="正射影像圖(混合)">
                    {/* https://ithelp.ithome.com.tw/articles/10194831 */}
                    <WMSTileLayer
                        attribution='&amp;copy <a href="https://maps.nlsc.gov.tw/S09SOA/">國土測繪圖資服務雲</a> contributors'
                        url="https://wmts.nlsc.gov.tw/wmts/PHOTO_MIX/default/GoogleMapsCompatible/{z}/{y}/{x}.jpg"
                    />
                </BaseLayer>
                <BaseLayer checked name="OpenStreetMap">
                    <TileLayer
                        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                </BaseLayer>
            </LayersControl>
            <ScaleControl position={"bottomleft"} />
            <LocateControl
                options={locateOptions}
                startDirectly={false}
            />
            {userMarker ? <Marker position={markerPosition} icon={addUserMarker} /> : null}
            {Loading ? null : <SideMenu locatePosition={locatePosition} getClosestLocation={getClosestLocation} />}
            {Loading ? (<DarkModal><LoadingModal /></DarkModal>) : (<MarkerClusterGroup showCoverageOnHover={false} >{addMarkers}</MarkerClusterGroup>)}
            {Loading ? null : (<EntranceLink refEntrance={refEntrance} />)}
            {Loading ? null : (<InfoLink />)}
            {Loading ? null : (<LegendLink />)}
            {Loading ? null : (<ShareLink />)}
        </Map>
    );
}

export default MapDiv;